export class SubscriptionOptions extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['purchaseOption', 'sellingPlan']
  }

  setupListeners () {
    super.setupListeners()

    this.update = this.update.bind(this)

    this.els.purchaseOption.elements.forEach((radio) => {
      this.listeners.add(radio, 'change', this.update)
    })

    if (this.frequency) {
      this.listeners.add(this.frequency, 'change', this.update)
    }

    this.update()
  }

  /**
   * @returns {void}
   */
  update () {
    this.els.purchaseOption.elements.forEach((radio) => {
      radio
        .closest('[data-subscription-option]')
        .classList.toggle('prd-BundlePicker_Option-selected', radio.checked)
    })

    this.els.sellingPlan.element.value =
      this.isSubscription && this.frequency ? this.frequency.value : ''
  }

  /**
   * @returns {HTMLSelectElement|null}
   */
  get frequency () {
    return this.els.frequency?.element || null
  }

  /**
   * @returns {boolean}
   */
  get isSubscription () {
    return this.els.purchaseOption.elements.some(
      (radio) => radio.checked && radio.value === 'subscription',
    )
  }
}

if (!customElements.get('bao-subscription-options')) {
  customElements.define('bao-subscription-options', SubscriptionOptions)
}
